import { library, dom } from '@fortawesome/fontawesome-svg-core'

// import the icons which u want to use
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons' // example

// SOLID ICONS
import { 
	faHeart, 
	faBookmark as fasBookmark,
	faMapMarkerAlt as fasMapMarkerAlt,
	faSmileBeam as fasSmileBeam,
	faBars as fasBars,
	faChevronDown as fasChevronDown,
	faChevronUp as fasChevronUp,
	faChevronLeft as fasChevronLeft
} from '@fortawesome/pro-solid-svg-icons'

// REGULAR ICONS
import { 
	faBookmark as farBookmark,
	faSpinner as farSpinner,
	faSearch as farSearch,
	faThumbsUp as farThumbsUp,
	faLocationArrow as farLocationArrow
} from '@fortawesome/pro-regular-svg-icons'

// LIGHT ICONS
import {
	faCommentLines as falCommentLines,
	faHeart as falHeart,
	faSnowflake as falSnowflake,
	faSun as falSun,
	faCog as falCog,
	faMap as falMap,
	faSlidersH as falSlidersH,
	faChild as falChild,
	faDog as falDog,
	faWheelchair as falWheelchair,
	faBabyCarriage as falBabyCarriage,
	faAngleDoubleRight as falAngleDoubleRight,
	faStopwatch as falStopwatch,
	faMapMarkerAlt as falMapMarkerAlt,
	faDirections as falDirections,
	faCreditCard as falCreditCard,
	faPhone as falPhone,
	faEnvelope as falEnvelope,
	faExternalLink as falExternalLink,
	faCheck as falCheck,
	faTimes as falTimes,
	faChevronLeft as falChevronLeft,
	faChevronRight as falChevronRight,
	faChevronDown as falChevronDown,
	faShare as falShare,
	faCrosshairs as falCrosshairs,
	faWifiSlash as falWifiSlash,
	faDownload as falDownload,
	faIdCard as falIdCard,
	faSignOut as falSignOut,
	faSync as falSync
} from '@fortawesome/pro-light-svg-icons'

// BRAND ICONS
import {
	faFacebook as fabFacebook,
	faTwitter as fabTwitter
} from '@fortawesome/free-brands-svg-icons'

// add your icons to the library
// library.add(faUserSecret) // example
library.add(faHeart)
library.add(farBookmark)
library.add(fasBookmark)
library.add(fasMapMarkerAlt)
library.add(fasSmileBeam)
library.add(fasBars)
library.add(farSpinner)
library.add(falCommentLines)
library.add(falHeart)
library.add(falSnowflake)
library.add(falSun)
library.add(falCog)
library.add(fasChevronDown)
library.add(fasChevronUp)
library.add(fasChevronLeft)
library.add(farSearch)
library.add(falMap)
library.add(falSlidersH)
library.add(farThumbsUp)
library.add(farLocationArrow)
library.add(falChild)
library.add(falDog)
library.add(falWheelchair)
library.add(falBabyCarriage)
library.add(falAngleDoubleRight)
library.add(falStopwatch)
library.add(falMapMarkerAlt)
library.add(falDirections)
library.add(falCreditCard)
library.add(falPhone)
library.add(falEnvelope)
library.add(falExternalLink)
library.add(falCheck)
library.add(falTimes)
library.add(falChevronRight)
library.add(falChevronLeft)
library.add(falChevronDown)
library.add(falShare)
library.add(fabFacebook)
library.add(fabTwitter)
library.add(falCrosshairs)
library.add(falWifiSlash)
library.add(falDownload)
library.add(falIdCard)
library.add(falSignOut)
library.add(falSync)

dom.watch()

const IconLibrary = library
export default IconLibrary